<template>

  <div class="text-left" v-if="row[column]">
    <span class="inline" v-if="currencySymbol">{{getCurrencySign(row['currency'])}}</span>
    <span class="inline">{{formatToDollars(row[column]).toLocaleString()}}</span>
    <span class="inline" v-if="currency && !currencySymbol">{{'&nbsp;' + row['currency']}}</span>
  </div>

  <span v-else>
    0
  </span>

</template>

<script>
  export default {
    name: 'CentsToBills',
    props: ['row', 'column', 'currency', 'currencySymbol'],
  }
</script>
